import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { StatisticsService } from '@app/services/Statistics/Statistics.service';
import { CSVDataService } from '@app/export/CSVDataService';
import { MenuItem } from 'primeng/api';
import { NavigationEnd, Router } from '@angular/router';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-presence-institutionlevel',
  templateUrl: './presence-institutionlevel.component.html'
})
export class PresenceInstitutionlevelComponent implements OnInit {
form;
  
  result;
  showSpinner = false;
  test: number[];
  items: MenuItem[];

  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private router: Router,
    private statisticsService: StatisticsService) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clearReport();
      }
    });
  }

  ngOnInit() {
    this.form = this.fb.group({
      lodges: ['', ''],
      camps: ['', ''],
      institutions: ['', ''],
      parentInstitutionId: ['', ''],
      selectedFilter: ['', ''],
      selectedYears: ['', ''],
      districts: ['', '']
    });
    this.setItems();
  }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }];
  }

  exportToCSV() {
    // tslint:disable-next-line:max-line-length
    const firstrow = 'Institution;Distrikt;Mötestyp;År;Antal möten;Antal egnas besök i annan inst.;Antal gäster från annan institution;Egna närvarande;Antal medlemmar i logen vid årets slut';
    const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
    const filnamn = 'NärvaroPåInstitutionsnivå_' + datum;
    let data: any[] = [];
    this.result.forEach(x => {
      const row = {
        col1: x.name,
        col2: x.district,
        col3: x.meetingType,
        col4: x.year,
        col5: x.numberOfMeetings,
        col6: x.numberOfOwnMembersInOtherInstitutions,
        col7: x.numberOfGuestsFromOtherInstitutions,
        col8: x.attendance,
        col9: x.membersAtEndOfYear
      };
      data.push(row);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
  }

  createReport(evt) {
    this.showSpinner = true;
    const statisticsInput = {
      generalStatisticsReportInputModel: evt.value
    };
    this.statisticsService.GetAttendanceStatisticsPerInstitutionReport(statisticsInput).subscribe((response: any) => {
      if (this.form.get('selectedFilter').value === '1' || this.form.get('selectedFilter').value === '2') {
        this.result = response.result;
        this.showSpinner = false;
      } else {
        this.result = response;
        this.showSpinner = false;
      }
    });
  }

  narvaroPerMedlem(evt) {
    this.showSpinner = true;
    const statisticsInput = {
      generalStatisticsReportInputModel: {
        camps: null,
        lodges: "B",
        institutions: [312],
        parentInstitutionId: null,
        selectedFilter: "3",
        selectedYears: [2017, 2018, 2020],
        selectedMeetingInstitutionFilter: "3",
        duringFirstDate: null,
        selectedMeetingTypeFilter: "4"
      }
    };
    this.statisticsService.GetAttendanceStatisticsPerMemberReport(statisticsInput).subscribe((response: any) => {
      this.showSpinner = false;
    });
  }

  narvaroPerManad(evt) {
  }

  search() {
  }

  clearReport() {
    this.result = null;
    this.form?.reset();
  }

}
